export const NotificationStoreModuleSymbol = Symbol.for('NotificationStoreModule')
